import { CreateMilestoneTask } from "../../../../domain/projectMilestones/createMilestoneTask";
import DateField from "../../../shared/components/forms/DateField";
import TextAreaField from "../../../shared/components/forms/TextAreaField";
import TextField from "../../../shared/components/forms/TextField";

interface Props{
    createMilestoneTaskData: CreateMilestoneTask;
    setCreateMilestoneTaskData: React.Dispatch<React.SetStateAction<CreateMilestoneTask>>;
}

export default function ModalCreateMilestoneTaskSection({ createMilestoneTaskData, setCreateMilestoneTaskData }: Props) {
    return (
        <div className='row'>

             <div className='col-12 col-md-6 mb-3'>
                <TextField
                    name='task'
                    label='Tarea'
                    required
                    value={createMilestoneTaskData.task}
                    onChange={(name, value) => {
                        setCreateMilestoneTaskData(prev => ({ ...prev, task: value as string }));
                    }}
                />
            </div>

            <div className='col-12 col-md-6 mb-3'>
                <DateField
                    label='Fecha Realizada'
                    name='completedDate'
                    required={false}
                    value={
                        createMilestoneTaskData.completedDate
                            ? createMilestoneTaskData.completedDate.toISOString().split('T')[0]
                            : null
                    }
                    onChange={(name, value) => {
                        setCreateMilestoneTaskData(prev => ({
                            ...prev,
                            completedDate: value ? new Date(value as string) : null
                        }));
                    }}
                />
            </div>

            <div className='col-12 col-md-6 mb-3'>
                <TextField
                    label='Horas Estimadas'
                    name='estimatedHours'
                    required
                    value={createMilestoneTaskData.estimatedHours}
                    onChange={(name, value) => {
                        setCreateMilestoneTaskData(prev => ({ ...prev, estimatedHours: Number(value) }));
                    }}
                />
            </div>

            <div className='col-12 col-md-6 mb-3'>
                <TextField
                    label='Horas Reales'
                    name='actualWorkHours'
                    required={false}
                    value={createMilestoneTaskData.actualWorkHours}
                    onChange={(name, value) => {
                        setCreateMilestoneTaskData(prev => ({ ...prev, actualWorkHours: Number(value) }));
                    }}
                />
            </div>

            <div className='col-12 mb-3'>
                <TextAreaField
                    name='comments'
                    label='Descripción'
                    required
                    value={createMilestoneTaskData.comments}
                    onChange={(name, value) => {
                        setCreateMilestoneTaskData(prev => ({ ...prev, comments: value as string }));
                    }}
                />
            </div>
        </div>
    );
}